import "./TextEdit.scss";
import { useEffect } from "react";
import {
  Row,
  Input,
  Col,
  Checkbox,
  Form,
  Switch,
  InputNumber
} from "antd";
import { useTranslation } from "react-i18next";

const TextEdit = ({ form, section, component, lang, handleChangeValuesSection }) => {
	const { t } = useTranslation()
    const { getFieldDecorator, validateFields, setFieldsValue } = form;

    useEffect(() => {
        setFieldsValue({['title-text-' + component.id]: component.title && component.title[lang]})
        validateFields()
    }, [lang])

    const handlerChangeTitle = (value) => {
        let title = component.title??{}
        title[lang] = value
        handlerChangeAttr('title', title)
    }

    const handlerChangeAttr = (attr, value) => {
        component[attr] = value
        handleChangeValuesSection(section)
    }

    return (
        <div className="form-manager-row-component-text">
            <Row style={{padding: 20}}>
                <Col md={3} sm={4}>{t('forms.manager.section.fieldsTitle', {ns: 'forms'})}</Col>
                <Col span={7}>
                    { component.hasTitle ?
                        <Form.Item>
                            { getFieldDecorator('title-text-' + component.id, {
                                initialValue: component.title && component.title[lang],
                                rules:
                                    [
                                        { required: true, message: t('messages.aml.requestedField') }
                                    ]
                                })(
                                    <Input onChange={(e) => handlerChangeTitle(e.target.value)} size="small"  />
                                )
                            }
                        </Form.Item>
                        :
                        <Input disabled={true} size="small" />
                    }
                </Col>
                <Col span={1} className="chk-title">
                    <Switch checked={component.hasTitle} onChange={(e) => handlerChangeAttr('hasTitle', e)} size="small" />
                </Col>
                <Col span={3}>
                    <Checkbox size="small" checked={component.required} onChange={(e) => handlerChangeAttr('required', e.target.checked)} >
                        {t('messages.aml.requested')}
                    </Checkbox>
                </Col>
                <Col span={3}>
                    {t('forms.validation.max_characters', {ns: 'forms'})}
                </Col>
                <Col span={3}>
                    <Form.Item>
                        { getFieldDecorator('max-length-' + component.id, {
                            initialValue: component.maxLength,
                            rules:
                                [
                                    { required: true, message: t('messages.aml.requestedField') }
                                ]
                            })(
                                <InputNumber onChange={(e) => handlerChangeAttr('maxLength', e)} size="small" min={10} max={5000} step={100} />
                            )
                        }
                    </Form.Item>
                </Col>
            </Row>
        </div>
    )
}

export default TextEdit;
